export default function () {
  return {
    startDate: undefined,
    isLoadingCancelationServiceDate: undefined,
    isCancelationServiceActive: undefined,
    newlyInsuredPersons: {},
    shouldResetSelectedAgreementId: true,
    selectedAgreementId: null,
    shouldRefreshContracts: true,
    isBornRecently: undefined,
  };
}
